import { useEffect, useRef, useState } from 'react';

// Scales a fixed-size artboard (e.g. the 600×450 hero visual) down to fit its container's width.
const useFitScale = (designWidth) => {
    const ref = useRef(null);
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const update = () => setScale(Math.min(1, el.clientWidth / designWidth));
        update();
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(update);
        observer.observe(el);
        return () => observer.disconnect();
    }, [designWidth]);

    return [ref, scale];
};

export default useFitScale;
